import {connect} from 'react-redux';
import Image, {ImageProps} from './Image';
import MediaDimensionsModel from '../../types/MediaDimensionsModel';
import ReduxState from '../../types/ReduxState';
import Action from '../../redux/Actions';
import {Dispatch} from 'redux';

const mapStateToProps = (state: ReduxState, ownProps: ImageContainerProps): Partial<ImageProps> => {
   return {
      mediaUrl: state.currentReviewVersion && state.currentReviewVersion.MediaUrl || '',
      allowZoom: ownProps.allowZoom || false,
      allowAnnotation: ownProps.allowAnnotation,
      storeAnnotation: ownProps.storeAnnotation,
      mediaDimensions: state.mediaDimensions,
      annotationMode: state.annotationMode
   };
};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>): Partial<ImageProps> => {
   return {
      setMediaDimensions: (mediaDimensions: MediaDimensionsModel) => {
         dispatch(Action.setMediaDimensions(mediaDimensions));
      }
   };
};

export default connect(mapStateToProps, mapDispatchToProps)(Image);

interface ImageContainerProps {
   allowZoom: boolean;
   allowAnnotation: boolean;
   storeAnnotation?(annotation: string): void;
}
